import { createContext, useContext } from "react";

export const SecretaryCorespondenceFormContext = createContext();

export const useSecretaryCorespondenceFormContext = () => useContext(SecretaryCorespondenceFormContext);